<!-- 订单详情组件 -->
<template>
    <div class="tipsBox" :class="[type == 'warning' ? 'warning' : 'err']" v-if="isShowTips" ref='test'>
        <!-- <div class="close" @click="CloseEvent()"><span class="el-icon-close"></span></div> -->
        <div v-if="title" class="tipsheader">
            <div class="logo">
                <img src="@/assets/images/warn.png" alt="" v-if="type == 'warning'" class="img">
                <img src="@/assets/images/err.png" alt="" v-if="type == 'err'" class="img">
                <span class="word">{{ title }}</span>
            </div>
            <div class="close" v-if="isShowClose" @click="CloseEvent()">
                <span class="el-icon-close"></span>
            </div>
        </div>
        <div class="message" :class="{ isPadding: title !== '' }">
            <img src="@/assets/images/warn.png" alt="" v-if="type == 'warning' && title == ''" class="img"
                style="vertical-align: sub;">
            <img src="@/assets/images/err.png" alt="" v-if="type == 'err' && title == ''" class="img"
                style="vertical-align: sub;">
            <span v-html="tipsmessage"></span>
        </div>
    </div>
</template>
<script>
export default {
  name: 'tipsHeader',
  props: {
    isShowTips: {
      type: Boolean,
      default: false,
    },
    isShowClose: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'warning',
    },
    // 倒计时是否结束
    isSettime: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    tipsmessage: {
      type: String,
      default: '',
    },
  },
  // computed: {
  //     orderGetter() {
  //         return this.order;
  //     }
  // },
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    CloseEvent() {
      this.$emit('closeTips');
    },
    getHeight() {
      this.$nextTick(() => {
        const element = this.$refs.test;
        const height = element.offsetHeight;
      });
    },
  },
  mounted() {
    // this.getHeight()
  },
};
</script>
<style lang="scss" scoped>
.warning {
    background: #FFF7E8;
}

.err {
    background: #FFECE8;
}

.tipsBox {
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
     position: sticky;
    top: 0;
    z-index: 9999;

    .tipsheader {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .word {
            font-weight: 500;
            font-size: 16px;
            color: #1D2129;
            // margin-left: 8px;
        }

        .close {
            color: #4E5969;
            // position: absolute;
            // right: 16px;
            // top: 16px;
            // top:0px;
            // right: 0px;
        }
    }

    .message {
        font-weight: 400;
        font-size: 14px;
        color: #1D2129;
        line-height: 22px;
        text-align: left;
        margin-top: 4px
    }

    .isPadding {
        padding-left: 24px;
    }

    .img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        display: inline-block;
        margin-right: 8px;

    }
}

.time {
    color: #FF9B3A !important;
    font-weight: 700 !important;
    font-size: 18px !important;
}
.logo{
    display: flex;
    align-items: center;

}
</style>
